
export const transferToDianShiFormOptions = {
  transferCustomer: ['线索平台'],
  district: ['东区', '西区', '南区', '北区'],
  districtWithEmpty: ['东区', '西区', '南区', '北区', '无'],
  intention: ['高意向客户', '中意向客户', '低意向客户', '潜力客户'],
  intentionType: ['首购', '复购'],
  expectBuyDate: ['3个月内', '6个月内', '1年内', '1年以上', '暂不明确'],
  memberScale: ['20人以下', '20-100人', '100-500人', '500-1000人', '1000-5000人', '5000人以上'],
  monthConsumption: ['500元/月以下', '500-1000元/月', '1000-5000元/月', '5000-10000元/月', '10000-50000元/月', '50000元以上', '暂不明确'],
  communicateAttitude: ['愿意沟通', '中性', '客户要求不再联系', '暂不明确'],
  position: ['决策者', '影响者', '知情者', '使用者', '其他'],
  cloudVendorUse: ['腾讯云', '阿里云', '华为云', 'IDC', 'xx云', '其它', '不详'],
}

export const transferFormOptions = {
  transferCustomer: ['无'],
}

export const aiConfigMap = {
  customer: {
    tip: '提示信息',
    fieldList: [
      {
        label: '客户信息',
        key: 'customer',
        children: [
          {
            label: '【行业】',
            key: 'custIndustry1Name',
          },
          {
            label: '【企业性质】',
            key: 'stateOwnedEntrpr',
          },
          {
            label: '【是否中国500强】',
            key: 'isChina500',
          },
          {
            label: '【是否省100强】',
            key: 'isProv100',
          },
          {
            label: '【注册资本】',
            key: 'registerCap',
          },
          {
            label: '【分支机构数】',
            key: 'branchNum',
          },
          {
            label: '【是否上市】',
            key: 'isIpo',
          },
          {
            label: '【历史参会次数】',
            key: 'actNum',
          },
          {
            label: '【已购产品组合】',
            key: 'prodClass4NameCombo',
          },
        ],
      },
      {
        label: '竞品分析',
        key: 'competitors',
        children: [
          {
            label: '',
            key: 'adoption',
            // 是否根据返回结果直接展示
            autoDisplay: true,
          },
        ],
      },
    ],
  },
  intention: {
    tip: '提示信息',
    fieldList: [
      {
        label: '关键信息',
        key: 'keyInfo',
        children: [
          {
            label: '【公司】',
            key: 'customerName',
          },
          {
            label: '【职务】',
            key: 'position',
          },
          {
            label: '【感兴趣产品】',
            key: 'needProduct',
          },
          {
            label: '【预算】',
            key: 'budget',
          },
        ],
      },
      {
        label: '需求描述',
        key: 'desc',
        children: [
          {
            label: '【需求场景】',
            key: 'businessDemand',
          },
          {
            label: '【项目阶段】',
            key: 'projectPhases',
          },
          {
            label: '【商务对接】',
            key: 'businessMatchmaking',
          },
        ],
      },
    ],
  },
}
